// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDiPahaiBl34pYgjumZn6mYTE0vS67mJvs",
  authDomain: "chat-app-practice-f2340.firebaseapp.com",
  databaseURL: "https://chat-app-practice-f2340-default-rtdb.firebaseio.com",
  projectId: "chat-app-practice-f2340",
  storageBucket: "chat-app-practice-f2340.firebasestorage.app",
  messagingSenderId: "406078338290",
  appId: "1:406078338290:web:2e3303ba9eb7d771d54c6b",
  measurementId: "G-S6FV21FRGB",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getDatabase(app);
